import React, { useContext, useEffect, useState } from 'react';

import InfoWidget from '@totem/components/customDashboard/info_widget/InfoWidget';
import {
  Point,
  Points,
} from '@totem/components/customDashboard/info_widget/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { GraphPoint, SumRequest } from '@totem/types/charts';
import { defaultChartColors, shuffle } from '@totem/utilities/charts';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';

const ProjectsByBuilding = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [chartData, setChartData] = useState<Points>([]);
  const [recordTotal, setRecordTotal] = useState<number>(0);
  const [colors, setColors] = useState<string[]>(defaultChartColors);

  const createChartData = (chartDataResults: GraphPoint[]) => {
    let total = 0;
    const data: Points = chartDataResults.map((graphPoint) => {
      return {
        id: graphPoint.id,
        label: graphPoint.x,
        value: graphPoint.y,
      };
    });

    for (let idx = 0; idx < chartDataResults.length; idx++) {
      total += chartDataResults[idx].y;
    }

    setRecordTotal(total);

    setChartData(data);

    setColors(shuffle(defaultChartColors));
  };

  useEffect(() => {
    const params: SumRequest = {
      idFieldName: 'buildingId',
      labelFieldName: 'building.name',
      filters: [
        {
          field: 'type',
          values: ['Site Project', 'Project'],
        },
      ],
    };

    fetch(`${TICKETS_ENDPOINT}/charts/summary`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((result: GraphPoint[]) => {
        createChartData(result);
      });
  }, [userProfile.organization.id, getApiToken]);

  const handleItemClicked = (index: number, point: Point) => {
    if (index >= 0) {
      window.open(
        `/dashboard/ticketing?buildingId=${point.id}&status=OPEN&status=RESOLVED&type=Site%20Project`,
        `${point.label}`,
      );
    }
  };

  return (
    <InfoWidget
      points={chartData}
      chartTitle="Projects / Building"
      title="Projects"
      total={recordTotal.toString(10)}
      onPointClicked={handleItemClicked}
      chartOptions={{ colors }}
    />
  );
};

export default ProjectsByBuilding;
